var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDotsVertical(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "dots-vertical"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Vector"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8 2.97991C8.55228 2.97991 9 2.5367 9 1.98996C9 1.44322 8.55228 1 8 1C7.44772 1 7 1.44322 7 1.98996C7 2.5367 7.44772 2.97991 8 2.97991Z",
    fill: "#218BFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 8.86803C8.55228 8.86803 9 8.42482 9 7.87808C9 7.33134 8.55228 6.88812 8 6.88812C7.44772 6.88812 7 7.33134 7 7.87808C7 8.42482 7.44772 8.86803 8 8.86803Z",
    fill: "#218BFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 15C8.55228 15 9 14.5568 9 14.01C9 13.4633 8.55228 13.0201 8 13.0201C7.44772 13.0201 7 13.4633 7 14.01C7 14.5568 7.44772 15 8 15Z",
    fill: "#218BFF"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDotsVertical);
export default __webpack_public_path__ + "static/media/dots-vertical.e920b19208b935befe8c7f179e20f48b.svg";
export { ForwardRef as ReactComponent };